/**
 * Brittfurn Upholstery, möbel-PDP integration
 * Loaded globally via theme.liquid <script> tag.
 * Survives Shopify Section Rendering re-hydration because the asset stays attached.
 */
(function () {
  if (window.__bfUpholsteryLoaded) return;
  window.__bfUpholsteryLoaded = true;

  // Samma host som account-exchange, cookien är host-only, så alla anrop
  // MÅSTE gå mot samma domän som satte den.
  const BACKEND = (document.querySelector('meta[name="bf-backend-url"]') || {}).content
    || "https://backend-sam-8064s-projects.vercel.app";

  // ============================================================
  // Auth, bearer-token i localStorage istället för tredjepartscookie
  // (Safari/inkognito blockerar cookies mot vercel.app från brittfurn.se).
  // Token hämtas via HMAC-bootstrap (window.bfCustomerBootstrap, renderad i Liquid)
  // och delas med account-systemet via samma localStorage-nyckel.
  // ============================================================
  const TOKEN_KEY = "bf_token";
  window.bfUpAuth = window.bfUpAuth || (function () {
    function getToken() { try { return localStorage.getItem(TOKEN_KEY) || ""; } catch { return ""; } }
    function setToken(t) { try { t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY); } catch {} }
    function decodeJwt(t) {
      try { return JSON.parse(atob(t.split(".")[1].replace(/-/g, "+").replace(/_/g, "/"))); }
      catch { return null; }
    }
    // Släng cachead token som gått ut eller tillhör en annan kund, så save och
    // list alltid använder den inloggade kundens identitet. Utan detta kan en
    // gammal token från ett tidigare konto peka på fel (ofta tom) pool.
    function pruneStaleToken() {
      const t = getToken();
      if (!t) return;
      const p = decodeJwt(t);
      const boot = window.bfCustomerBootstrap;
      const expired = !p || (p.exp && p.exp * 1000 < Date.now() + 60000);
      const wrongCustomer = p && boot && String(p.sub) !== String(boot.customer_id);
      if (expired || wrongCustomer) setToken("");
    }
    function headers(extra) {
      const h = Object.assign({}, extra);
      const t = getToken();
      if (t) h.Authorization = "Bearer " + t;
      return h;
    }
    let exchangePromise = null;
    function exchange() {
      if (exchangePromise) return exchangePromise;
      exchangePromise = (async () => {
        const b = window.bfCustomerBootstrap;
        if (!b) return "";
        try {
          const r = await fetch(BACKEND + "/api/account/exchange", {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(b),
          });
          if (!r.ok) return "";
          const j = await r.json();
          if (j && j.token) { setToken(j.token); return j.token; }
        } catch (e) { console.warn("[bfUpAuth] exchange failade:", e.message); }
        return "";
      })();
      exchangePromise.finally(() => { exchangePromise = null; });
      return exchangePromise;
    }
    // fetch med Authorization-header; vid 401 hämtas ny token via exchange och anropet görs om en gång
    async function authFetch(url, opts) {
      opts = Object.assign({}, opts);
      opts.credentials = "include";
      const baseHeaders = opts.headers;
      pruneStaleToken();
      if (!getToken() && window.bfCustomerBootstrap) await exchange();
      opts.headers = headers(baseHeaders);
      let r = await fetch(url, opts);
      if (r.status === 401 && window.bfCustomerBootstrap) {
        setToken("");
        const t = await exchange();
        if (t) {
          opts.headers = headers(baseHeaders);
          r = await fetch(url, opts);
        }
      }
      return r;
    }
    // Kom-ihåg-var-jag-var: Shopifys nya kontoinloggning tappar return_to,
    // så vi sparar sidan i sessionStorage innan login och redirectar tillbaka
    // vid första sidladdningen som inloggad.
    const RETURN_KEY = "bf_return_to";
    function rememberReturn(path) {
      try {
        sessionStorage.setItem(RETURN_KEY, JSON.stringify({
          p: path || (location.pathname + location.search),
          t: Date.now(),
        }));
      } catch {}
    }
    return { getToken, setToken, headers, exchange, authFetch, pruneStaleToken, rememberReturn, RETURN_KEY };
  })();

  // Fånga klick på alla inloggningslänkar (kontoikon, login-gates, hint-texter)
  // och spara return-målet, länkens egen return_to om den finns, annars nuvarande sida.
  document.addEventListener("click", function (e) {
    const a = e.target.closest('a[href*="customer_authentication"], a[href*="/account/login"]');
    if (!a) return;
    let target = "";
    try { target = new URL(a.href, location.origin).searchParams.get("return_to") || ""; } catch {}
    window.bfUpAuth.rememberReturn(target || undefined);
  }, true);

  // Efter inloggning: tillbaka till sidan kunden var på (max 30 min gammal notering).
  (function restoreAfterLogin() {
    if (!window.bfCustomerBootstrap) return; // inte inloggad
    let saved = null;
    try { saved = JSON.parse(sessionStorage.getItem("bf_return_to") || "null"); } catch {}
    if (!saved || !saved.p) return;
    try { sessionStorage.removeItem("bf_return_to"); } catch {} // före redirect, aldrig loop
    if (Date.now() - (saved.t || 0) > 30 * 60 * 1000) return;
    const here = location.pathname + location.search;
    if (saved.p === here || !saved.p.startsWith("/")) return;
    location.replace(saved.p);
  })();

  // ============================================================
  // Helpers
  // ============================================================
  function isUpholsteredMobel() {
    // Read product data from the Shopify product JSON (available as window.product or in scripts)
    // Fallback: inspect the page DOM for typical möbel markers
    const path = window.location.pathname;
    if (!path.startsWith("/products/")) return false;
    // Find product handle
    const handle = path.split("/products/")[1].split("?")[0];
    if (!handle) return false;
    // Skip tyger/tapeter/etc
    if (/tyg-|tapet-|matta-|lampa-|gardin/.test(handle)) return false;
    return true; // Treat all /products/* as möbel-PDP candidates, then double-check via product fetch
  }

  async function fetchProductData(handle) {
    try {
      const r = await fetch(`/products/${handle}.json`);
      if (!r.ok) return null;
      const j = await r.json();
      return j.product;
    } catch { return null; }
  }

  function productIsUpholstered(product) {
    if (!product) return false;
    // ENDAST Jio-möbler har "Välj tyg", övriga möbler (t.ex. Chesterfield i läder)
    // behåller sin vanliga variantväljare och prisvisning.
    if ((product.vendor || "").toLowerCase() !== "jio möbler") return false;
    const tags = (product.tags || "").toLowerCase();
    const type = (product.product_type || "").toLowerCase();
    return /fåtölj|soffa|tygfåtöljer|klädd|upholstered/.test(tags) ||
           /fåtölj|soffa|möbel/.test(type) ||
           (/möbler|möbel/.test(type) && /pall|stol|karmfåtölj/.test(tags));
  }

  // ============================================================
  // UX cleanups on möbel-PDP
  // ============================================================
  function applyUX() {
    // Hide single-variant "Utförande" dropdown + the duplicate .rio-options pill
    document.querySelectorAll("[data-variant-input]").forEach(sel => {
      if (sel.dataset.bfUpHidden) return;
      if (sel.querySelectorAll("option").length <= 1) {
        sel.dataset.bfUpHidden = "1";
        // Hide only the select wrapper, NOT the enclosing .product-block
        // (the block may also host our injected button or other content)
        const inner = sel.closest(".product-form__input") || sel.parentElement;
        if (inner) inner.style.display = "none";
      }
    });
    document.querySelectorAll(".rio-options").forEach(el => {
      if (el.dataset.bfUpHidden) return;
      const txt = (el.textContent || "").toLowerCase();
      if (/utförande/.test(txt)) { el.dataset.bfUpHidden = "1"; el.style.display = "none"; }
    });

    // Reformat price display
    document.querySelectorAll(".product-title-main-price, [data-product-price]").forEach(el => {
      if (el.dataset.bfUpFormatted === "1") return;
      const original = el.innerHTML.trim();
      if (!original || /bf-up-price-prefix/.test(original)) return;
      el.dataset.bfUpFormatted = "1";
      el.innerHTML =
        '<span class="bf-up-price-prefix">' + window.theme.strings.bfPriceFrom + '</span>' +
        original +
        '<span class="bf-up-price-suffix">' + window.theme.strings.bfPriceExclFabric + '</span>';
    });

    // Hide "Kontakta oss för kostnadsfri offert" sales_point
    document.querySelectorAll(".product-block--sales-point").forEach(block => {
      const txt = (block.textContent || "").toLowerCase();
      if (txt.includes("kostnadsfri offert") && !/tygåtgång/.test(txt)) {
        block.style.display = "none";
      }
    });
  }

  // ============================================================
  // Inject CSS (always)
  // ============================================================
  function injectStyle() {
    if (document.getElementById("bf-up-styles")) return;
    const style = document.createElement("style");
    style.id = "bf-up-styles";
    style.textContent = `
      .bf-up-save { margin: 16px 0 !important; font-family: inherit; max-width: 460px; display: block !important; visibility: visible !important; opacity: 1 !important; }
      .bf-up-save__btn { display: inline-flex !important; align-items: center; gap: 10px; width: 100%; padding: 14px 22px; background: #1a1a1a !important; color: #fff !important; border: 1px solid #1a1a1a; font-size: 13px; letter-spacing: .12em; text-transform: uppercase; cursor: pointer; transition: all 0.2s ease; justify-content: center; font-family: inherit; }
      .bf-up-save__btn:hover { background: #2c2c2c !important; }
      .bf-up-save__btn[data-saved="true"] { background: #fff !important; color: #1a1a1a !important; }
      .bf-up-save__btn[data-saved="true"] .bf-up-save__plus { display: none; }
      .bf-up-save__btn[data-saved="true"] .bf-up-save__check { display: block !important; }
      .bf-up-save__icon { flex-shrink: 0; }
      .bf-up-save__hint { margin: 8px 0 0; font-size: 12px; color: #6B6B6B; line-height: 1.5; }
      .bf-up-save__hint a { color: #1a1a1a; text-decoration: underline; }
      .bf-up-price-prefix { font-size: 0.65em; letter-spacing: .12em; text-transform: uppercase; color: #6B6B6B; display: block; margin-bottom: 2px; }
      .bf-up-price-suffix { font-size: 0.55em; letter-spacing: 0.04em; color: #6B6B6B; display: block; margin-top: 4px; font-weight: 400; }
      .bf-up-toast { position: fixed; bottom: 24px; left: 50%; transform: translateX(-50%) translateY(120px); background: #1a1a1a; color: #fff; padding: 14px 22px; font-size: 13px; letter-spacing: .12em; z-index: 99999; opacity: 0; pointer-events: none; transition: transform 0.3s, opacity 0.3s; border-radius: 2px; max-width: 90vw; text-align: center; }
      .bf-up-toast--visible { opacity: 1; transform: translateX(-50%) translateY(0); }
    `;
    document.head.appendChild(style);
  }

  // ============================================================
  // Bootstrap
  // ============================================================
  async function init() {
    if (!isUpholsteredMobel()) return;
    injectStyle();
    const handle = window.location.pathname.split("/products/")[1].split("?")[0];
    const product = await fetchProductData(handle);
    if (!product || !productIsUpholstered(product)) return;
    // Capture customer for click handler use. bfCustomerBootstrap (server-renderad
    // när kunden är inloggad) är den pålitliga signalen, samma som auth använder.
    // window.__st.cid (Shopify-analytics) är opålitlig och saknas ofta.
    if (window.bfCustomerBootstrap && window.bfCustomerBootstrap.customer_id) {
      window.customer = { id: window.bfCustomerBootstrap.customer_id };
    } else if (window.__st && window.__st.cid) {
      window.customer = { id: window.__st.cid };
    }

    applyUX();

    // Keep the furniture-PDP UX polish alive across section re-renders.
    if (window.MutationObserver) {
      let scheduled = false;
      new MutationObserver(() => {
        if (scheduled) return;
        scheduled = true;
        setTimeout(() => {
          scheduled = false;
          applyUX();
        }, 100);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
